import React, { useContext, useState } from "react";
import { Col, Container, Row, Card, CardBody, CardHeader, Modal } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb/BreadCrumb";
import { useQuery, useQueryClient } from "react-query";
import { Avatar } from "antd";
import HistoryContext from "../../../Components/Hooks/HistoryContext";
import "../../Styles/style.css";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import avatar1 from "../../../assets/images/users/avatar-user.png";
import { getVehicules, getVehicleById } from "../../Vehicules/services/vehiculeApi";

import { getUserById } from "../../Drivers/services/driverApi";
import GeolocationMap from "../../../Components/Common/GeolocationMap";

const Cartes = () => {
  const { isLoading, isError, error, data: vehicules = [] } = useQuery("vehicules", getVehicules);
  const [isModalOpenExport, setIsModalOpenExport] = useState(false);
  const [selectedVehicleId, setSelectedVehicleId] = useState(null); 
  const { data: selectedVehicle, isLoading: vehicleLoading } = useQuery(
    ["vehicle", selectedVehicleId],
    () => getVehicleById(selectedVehicleId),
    {
      enabled: !!selectedVehicleId, 
    }
  );
  const history = useContext(HistoryContext);
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  const toggleModalExport = () => {
    setIsModalOpenExport((prev) => !prev);
  };

  document.title = `Cartes | ${process.env.REACT_APP_NAME} - ${process.env.REACT_APP_DESCRIPTION}`;
  const { data: user, isLoadingUser: userLoading, isErrorUser: userError, errorUser: userErrorMsg } = useQuery(
    ['user', selectedVehicle?.actualUserId],
    () => getDriverById(selectedVehicle?.actualUserId), 
    {
      enabled: !!selectedVehicle?.actualUserId, 
    }
  );
  const avatarImage= selectedVehicle?.fileName;
   const imageUrlV = avatarImage
   ? `${process.env.REACT_APP_API_MEDIA_URL}/print/${avatarImage}`:avatar1;
  

  const HeaderTable = () => (
    <div className="gap-3">
      <div className="d-flex justify-content-between align-items-center w-100">
        <div className="d-flex gap-3">
          <strong style={{ fontSize: "24px" }}>Carte</strong>
        </div>
      </div>
    </div>
  );

  if (isLoading) return <p>Loading...</p>;
  if (isError) return <p>Error: {error.message}</p>;

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb page="Cartes" history={history} />
          <Row>
            <Col>
              <Card id="contactList">
                <CardHeader>
                  <HeaderTable />
                </CardHeader>
                <CardBody className="pt-0">
                  <div className="row">
                    <div className="col-3">
                      <div className="card">
                        <div
                          style={{
                            color: "#252525",
                            fontFamily: "Raleway",
                            fontWeight: "600px",
                            fontSize: "18px",
                          }}
                        >
                          Véhicules{" "}
                          <span
                            style={{
                              fontFamily: "Inter",
                              fontWeight: "600px",
                              display: "inline-flex",
                              justifyContent: "center",
                              alignItems: "center",
                              width: "24px",
                              height: "24px",
                              borderRadius: "50%",
                              backgroundColor: "#F0F0F0",
                              color: "#252525",
                              fontSize: "11px",
                              marginLeft: "5px",
                            }}
                          >
                            {vehicules?.length}
                          </span>
                        </div>
                        <hr className="colored-hr" />
                        <div className="search-box me-2 mb-2">
                          <input
                            id="search-bar-0"
                            type="text"
                            className="form-control search"
                            placeholder={t("global.search_placeholder")}
                            style={{
                              borderRadius: "20px",
                              backgroundColor: "#F6F6F6",
                              fontSize: "12px",
                            }}
                          />
                          <i className="search-icon">
                            <FontAwesomeIcon icon={faSearch} />
                          </i>
                        </div>
                        <div className="row" style={{ maxHeight: "500px", overflowY: "auto" }}>
                          {vehicules.map((vehicule) => {
                            const avatarImage = vehicule?.fileName;
                            const imageUrl = avatarImage
                              ? `${process.env.REACT_APP_API_MEDIA_URL}/print/${avatarImage}`
                              : avatar1;
                            const { latitude, longitude } = vehicule?.location || {};
                            const locationText =
                              latitude && longitude ? `${latitude}, ${longitude}` : "Emplacement non dispo";
                            return (
                              <div key={vehicule.id} className="col-12">
                                <div
                                  className="card"
                                  style={{ width: "100%", height: "90px", border: "1px solid #D9D9D9" }}
                                >
                                  <div className="card-body">
                                    <Row>
                                      <Col md={6}>
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                          <Avatar
                                            src={imageUrl}
                                            alt={vehicule.model}
                                            style={{
                                              width: "30px",
                                              height: "30px",
                                              borderRadius: "50%",
                                              marginRight: "8px",
                                            }}
                                          />
                                          <span
                                            className="card-title"
                                            style={{
                                              color: "#252525",
                                              fontFamily: "Inter",
                                              fontWeight: "400",
                                              fontSize: "15px",
                                              display: "flex",
                                              justifyContent: "space-between",
                                              alignItems: "center",
                                            }}
                                          >
                                            {vehicule.model}
                                          </span>
                                        </div>
                                        <span style={{ marginLeft: "30px" }}>{locationText}</span>
                                      </Col>

                                      <Col
                                        md={6}
                                        style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}
                                      >
                                        <a
                                          style={{
                                            borderRadius: "20px",
                                            fontWeight: "500",
                                            fontFamily: "Inter",
                                            padding: "5px 10px",
                                            backgroundColor: "#F7F7F7",
                                            color: "#252525",
                                            border: "none",
                                            fontSize: "13px",
                                            textAlign: "end",
                                            cursor: "pointer",
                                          }}
                                          onClick={() => {
                                            setSelectedVehicleId(vehicule.id); 
                                            toggleModalExport();
                                          }}
                                        >
                                          Voir
                                        </a>
                                      </Col>
                                    </Row>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                    <div className="col-9">
                      <div className="card">
                        <div className="card-body">
                          <GeolocationMap/>
                        </div>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Modal
            isOpen={isModalOpenExport}
            toggle={toggleModalExport}
            centered
            style={{ width: "340px", height: "240px", borderRadius: "20px" }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <Avatar
                src={imageUrlV}
                style={{
                  width: "50px",
                  height: "50px",
                  borderRadius: "50%",
                  marginRight: "8px",
                  marginLeft: "20px",
                  marginTop: "10px",
                }}
              />
              <span
                style={{
                  fontSize: "16px",
                  color: "#252525",
                  fontFamily: "Inter",
                  fontWeight: "500px",
                  marginTop: "10px",
                  marginLeft: "20px",
                }}
              >
                {vehicleLoading ? "Chargement..." : selectedVehicle?.model}
              </span>
            </div>

            <Row>
              <Col md={6}>
                <div
                  style={{
                    marginLeft: "20px",
                    marginTop: "15px",
                    color: "#9B9B9B",
                    fontWeight: "400px",
                    fontFamily: "Inter",
                    fontSize: "14px",
                  }}
                >
                  Chauffeur
                </div>
              </Col>
              <Col md={6}>
                <div
                  style={{
                    marginRight: "20px",
                    marginTop: "15px",
                    color: "#252525",
                    fontWeight: "400px",
                    fontFamily: "Inter",
                    fontSize: "14px",
                    textAlign: "end",
                    textDecoration: "underline",
                  }}
                >
                  {user?.name|| "Inconnu"}
                </div>
              </Col>
            </Row>
            <hr className="colored-hr" />
            <Row>
              <Col md={6}>
                <div
                  style={{
                    marginLeft: "20px",
                    color: "#9B9B9B",
                    fontWeight: "400px",
                    fontFamily: "Inter",
                    fontSize: "14px",
                  }}
                >
                  N° Téléphone
                </div>
              </Col>
              <Col md={6}>
                <div
                  style={{
                    marginRight: "20px",
                    color: "#252525",
                    fontWeight: "400px",
                    fontFamily: "Inter",
                    fontSize: "14px",
                    textAlign: "end",
                  }}
                >
                  {user?.phone || "Inconnu"}
                </div>
              </Col>
            </Row>
            <hr className="colored-hr" />
            <Row>
              <Col md={6}>
                <div
                  style={{
                    marginLeft: "20px",
                    marginBottom: "30px",
                    color: "#9B9B9B",
                    fontWeight: "400px",
                    fontFamily: "Inter",
                    fontSize: "14px",
                  }}
                >
                  Position
                </div>
              </Col>
              <Col md={6}>
                <div
                  style={{
                    marginRight: "20px",
                    marginBottom: "30px",
                    color: "#252525",
                    fontWeight: "400px",
                    fontFamily: "Inter",
                    fontSize: "14px",
                    textAlign: "end",
                  }}
                >
                  {selectedVehicle?.location || "Inconnu"}
                </div>
              </Col>
            </Row>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Cartes;
